module.exports = __webpack_public_path__ + "static/space-bg-ae8fd8f59e9f47359e0fc9000e81e846.png";